import { Navigate, useLocation } from 'react-router-dom'

import { useAccessToken, useUserProfile } from 'store'

interface ProtectedRouteProps {
    children: React.ReactElement
    roles: string[]
    allowPublic?: boolean
}

const ProtectedRoute = ({
    roles,
    children,
    allowPublic = false
}: ProtectedRouteProps) => {
    const accessToken = useAccessToken()
    const userData = useUserProfile()
    const location = useLocation()

    const isAuthenticated = Boolean(accessToken)

    // Explicitly public protected-route exception
    if (!isAuthenticated && allowPublic) {
        return children
    }

    // Not logged in -> landing/home
    if (!isAuthenticated) {
        if (location.pathname.startsWith('/trial-link/')) {
            const token = location.pathname.replace('/trial-link/', '')

            if (token) {
                sessionStorage.setItem('tt', token)
            }
        }

        return <Navigate to="/" replace />
    }

    // Token exists, profile still loading
    if (!userData?.role) {
        return null
    }

    const role = userData.role.toLowerCase()

    // Logged in but wrong role -> home
    if (!roles.includes(role)) {
        return <Navigate to="/" replace />
    }

    return children
}

export default ProtectedRoute